import {
  CalendarAddAlt,
  DeliveryParcel,
  Information,
  SearchLocate,
} from "@carbon/icons-react";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

import OrderHeader from "../../components/orderHeader/OrderHeader";
import { useOrderContext } from "../../contexts/OrderContext";
import { useHeader } from "../../contexts/PageHeaderContext";
import { IStep } from "../../models/step";
import ProgressContent from "./screens/progressContent/ProgressContent";

export const newOutboundDeliverySteps: IStep[] = [
  {
    number: 1,
    text: "enterInfo",
    icon: <Information size={24} />,
    done: false,
  },
  {
    number: 2,
    text: "enterItems",
    icon: <DeliveryParcel size={24} />,
    done: false,
  },
  {
    number: 3,
    text: "enterTimes",
    icon: <CalendarAddAlt size={24} />,
    done: false,
  },
  {
    number: 4,
    text: "confirmOrder",
    icon: <SearchLocate size={24} />,
    done: false,
  },
];

const NewOutboundDelivery = () => {
  const { t } = useTranslation();
  const { savedProgress, progressLevel } = useOrderContext();
  const { updateHeader, updateSecondHeader } = useHeader();
  const [deliveryStatus, setDeliveryStatus] = useState<"DRAFT" | "OPEN">(
    "DRAFT",
  );

  const updateHeaders = () => {
    updateHeader(<>{t("createNewOutboundDelivery")}</>);
    updateSecondHeader(null);
  };

  useEffect(() => {
    updateHeaders();
  }, [t]);

  const handleCreationStatusChange = (status: "DRAFT" | "OPEN") => {
    setDeliveryStatus(status);
  };

  return (
    <div className="page-content">
      <Helmet title={t("createOutboundDelivery")} />
      <OrderHeader
        paddingBottom="16px"
        amount={savedProgress.deliveryItems?.length || 1}
        //@ts-ignore
        status={deliveryStatus}
      />
      <ProgressContent onCreationStatusChange={handleCreationStatusChange} />
    </div>
  );
};

export default NewOutboundDelivery;
